<template>
  <v-dialog
      v-model="activate"
      max-width="1200px"
      @click:outside="closeDialog"
      persistent
  >
    <v-card
        class="px-4"
        color="background"
    >
      <v-card-title>
        <vuse-section-definition
            :title="$t('Global.Nodes.nodosImport')"
            icon="mdi-file-import"
            class="ml-n4 pa-0 pb-4"/>
      </v-card-title>
      <v-card-text>
        <v-container class="mb-2 pa-0">
          <v-form ref="nodesForm">
            <v-sheet class="neu-glow px-6">
              <v-file-input
                  @change="loadCSvInput"
                  v-model="uploadedFile"
                  :error-messages="textError"
                  :label="selectYoursFilesText" />
            </v-sheet>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-text >
        <!-- New Addition -->
        <v-data-table
            v-if="!uploadedFileIsEmpty"
            :headers="headerCsvParsed"
            :items="dataCsvParsed"
            :items-per-page="5"
            :footer-props="{'items-per-page-options': [5, 10, 20]}"
            class="elevation-1 background" />

      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn color="blue darken-1" text @click="submitItem" :disabled="uploadedFileIsEmpty">
          <v-icon left id="upload-button">mdi-upload</v-icon>
          {{ $t('Global.Nodes.import') }}
        </v-btn>
      </v-card-actions>
      <v-btn
          icon
          absolute
          top
          right
          @click="closeDialog"
      >
        <v-icon small>close</v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapGetters} from "vuex";
import UtilsCSV from "@/mixins/UtilsCSV";

export default {
  name: "ImportNodesDialog",
  mixins: [UtilsCSV],
  props: {
    activate: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }

  },
  data() {
    return {
      dragover: false,
      uploadedFile: {},
      textError: '',
      listSize: [10, 25, 50, 100],
    }
  },
  computed: {
    ...mapGetters(['']),
    selectYoursFilesText() {
      return this.$t('Global.Nodes.selectYoursFiles')
    },
    uploadedFileIsEmpty(){
      if(!this.uploadedFile){
        return true
      }else{
        return !this.uploadedFile?.name
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close-dialog')
    },
    loadCSvInput(element) {
      const isCSV = !!element && element.type?.includes('csv')
      const verifyTypeCsv = Object.is(element, null) || Object.is(element, undefined);
      if (verifyTypeCsv) {
        this.textError = ''
      } else if (!verifyTypeCsv && isCSV) {
        this.uploadedFile = element
        this.readFile(element)
      } else {
        this.uploadedFile = {}
        this.textError = this.$t("Global.Nodes.errorTypeCsv")
      }
    },
    submitItem() {
      if (this.uploadedFile) {
        this.$emit("filesUploaded", this.uploadedFile);
        this.closeDialog();
      } else {
        console.error("There are no files to upload")
      }
    }
  },
}
</script>

